import { __module as n } from "./index.es62.js";
import { n as a } from "./index.es40.js";
var s = a, m = n.exports = Object.create(s), o = {
  tagName: "name"
};
Object.keys(o).forEach(function(e) {
  var t = o[e];
  Object.defineProperty(m, e, {
    get: function() {
      return this[t] || null;
    },
    set: function(r) {
      return this[t] = r, r;
    }
  });
});
var i = n.exports;
export {
  i as e
};
//# sourceMappingURL=index.es41.js.map
